import { makeStyles } from '@material-ui/core/styles';
import { farmInterestedPartyStyles } from '../farm/additional-party/farm-interested-party.styles';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(8),
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners
  },
  coApplicantContainer: {
    paddingBottom: theme.spacing(7)
  },
  driverContainer: {
    paddingBottom: theme.spacing(7)
  },
  cardFooter: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(4, 8),
    borderTop: `1px solid ${theme.colorPalette.beige_50}`,
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners
  },
  driverExcluded: {
    backgroundColor: theme.colorPalette.red_100
  },
  driverExcludedLabel: {
    color: theme.colorPalette.white,
    textDecoration: 'line-through'
  },
  driverExcludedReason: {
    display: 'flex',
    alignItems: 'center',
    color: theme.colors.light_text
  },
  ...farmInterestedPartyStyles(theme),
  fo41Container: {
    ...farmInterestedPartyStyles(theme).fo41Container,
    padding: theme.spacing(4, 8)
  }
}));

export default useStyles;
